export const NAME = "public/forgotPassword";
